import { ApiRequestError } from '@/lib/apiRequestError';

/** Messaggi operativi, senza esporre dettagli tecnici del backend. */
export function meetingDetailLoadError(error: unknown): string {
  const status = error instanceof ApiRequestError ? error.status : undefined;
  if (status === 401) return 'La sessione è scaduta. Accedi di nuovo per aprire il meeting.';
  if (status === 404) return 'Questo meeting non è più disponibile o non è accessibile.';
  if (status === 503) return 'Il controllo di accesso è temporaneamente non disponibile. Riprova tra poco.';
  return 'Non è stato possibile caricare il meeting. Riprova.';
}
